import {
  GET_CREDITOPTIONDETAIL,
  GET_CREDITOPTIONDETAIL_SUCCESS,
  GET_CREDITOPTIONDETAIL_FAIL,
  DELETE_CREDITOPTIONDETAIL,
  DELETE_CREDITOPTIONDETAIL_SUCCESS,
  DELETE_CREDITOPTIONDETAIL_FAIL,
  UPDATE_CREDITOPTIONDETAIL,
  UPDATE_CREDITOPTIONDETAIL_SUCCESS,
  UPDATE_CREDITOPTIONDETAIL_FAIL,
  ADD_NEW_CREDITOPTIONDETAIL,
  ADD_CREDITOPTIONDETAIL_SUCCESS,
  ADD_CREDITOPTIONDETAIL_FAIL,
  CREDITOPTIONDETAIL_LOADING,
  CREDITOPTIONDETAIL_RESET,
} from "./actionType";

export const resetCreditOptionDetailState = (actionType) => ({
  type: CREDITOPTIONDETAIL_RESET,
  payload: { actionType },
});

export const getCreditOptionDetailSuccess = (actionType, data) => ({
  type: GET_CREDITOPTIONDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getCreditOptionDetailFail = (actionType, error) => ({
  type: GET_CREDITOPTIONDETAIL_FAIL,
  payload: { actionType, error },
});

export const getCreditOptionDetail = data => ({
  type: GET_CREDITOPTIONDETAIL,
  payload: data,
});

export const getCreditOptionDetailLoading = () => ({
  type: CREDITOPTIONDETAIL_LOADING
});

export const deleteCreditOptionDetail = data => ({
  type: DELETE_CREDITOPTIONDETAIL,
  payload: data,
});

export const deleteCreditOptionDetailSuccess = data => ({
  type: DELETE_CREDITOPTIONDETAIL_SUCCESS,
  payload: data,
});

export const deleteCreditOptionDetailFail = error => ({
  type: DELETE_CREDITOPTIONDETAIL_FAIL,
  payload: error,
});

export const updateCreditOptionDetail = data => ({
  type: UPDATE_CREDITOPTIONDETAIL,
  payload: data,
});

export const updateCreditOptionDetailFail = error => ({
  type: UPDATE_CREDITOPTIONDETAIL_FAIL,
  payload: error,
});

export const updateCreditOptionDetailSuccess = data => ({
  type: UPDATE_CREDITOPTIONDETAIL_SUCCESS,
  payload: data,
});

export const addNewCreditOptionDetail = data => ({
  type: ADD_NEW_CREDITOPTIONDETAIL,
  payload: data,
});

export const addCreditOptionDetailSuccess = data => ({
  type: ADD_CREDITOPTIONDETAIL_SUCCESS,
  payload: data,
});

export const addCreditOptionDetailFail = error => ({
  type: ADD_CREDITOPTIONDETAIL_FAIL,
  payload: error,
});